import Layout from '@/container/Full'

const AffiliatesView = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesView')
const AffiliatesDashboard = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesDashboard')
const AffiliatesStatistics = () => import(/* webpackChunkName: "affiliates" */ 'Views/affiliates/Statistics/AffiliatesStatistics')
const MonthlyReport = () => import(/* webpackChunkName: "affiliates" */ 'Views/affiliates/Statistics/MonthlyReport')
const YearlyReport = () => import(/* webpackChunkName: "affiliates" */ 'Views/affiliates/Statistics/YearlyReport')
const LifetimeReport = () => import(/* webpackChunkName: "affiliates" */ 'Views/affiliates/Statistics/LifetimeReport')
const TrafficDetails = () => import(/* webpackChunkName: "affiliates" */ 'Views/affiliates/Statistics/TrafficDetails')
const AffiliatesCampaigns = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesCampaigns')
const AffiliatesBanners = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesBanners')
const AffiliatesPayments = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesPayments')
const PrintPaymentsList = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/PrintPaymentsList')
const AffiliatesLegal = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesLegal')
const AffiliatesLegalTos = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesLegalTos')
const AffiliatesLegalFtc = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliatesLegalFtc')
const MultipleAccounts = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/MultipleAccountView')
const AffiliatesAccountView = () => import(/* webpackChunkName: "affiliates" */ './../views/affiliates/AffiliateAccountView')

const routes = [
  {
    path: '/affiliates',
    component: Layout,
    meta: {
      breadcrumb: 'Affiliates',
      pageTitle: 'Affiliates',
      access_type: 'authorized'
    },
    children: [
      {
        path: '',
        component: AffiliatesView,
        meta: {
          title: 'Affiliates',
          pageTitle: 'Affiliates',
          access_type: 'authorized',
        },
        children: [
          {
            path: '',
            name: 'affiliates',
            component: AffiliatesDashboard,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates',
            }
          },
          {
            path: 'statistics',
            // name: 'affiliates-statistics',
            component: AffiliatesStatistics,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates / Statistics',
            },
            children: [
              {
                path: 'monthly-statistics',
                name: 'monthly-statistics',
                component: MonthlyReport,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / Monthly Statistics',
                },
              },
              {
                path: 'yearly-statistics',
                name: 'yearly-statistics',
                component: YearlyReport,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / Yearly Statistics',
                },
              },
              {
                path: 'lifetime-statistics',
                name: 'lifetime-statistics',
                component: LifetimeReport,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / Lifetime Statistics',
                },
              },
              {
                path: 'traffic-details',
                name: 'traffic-details',
                component: TrafficDetails,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / Traffic Details',
                },
              },
            ]
          },
          {
            path: 'banners',
            name: 'affiliates_banners',
            component: AffiliatesBanners,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates / Banners & Tracking',
            }
          },
          {
            path: '',
            component: AffiliatesLegal,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates',
            },
            children: [
              {
                path: 'tos',
                name: 'affiliates_legal_tos',
                component: AffiliatesLegalTos,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / Affiliate Terms of Service',
                },
              },
              {
                path: 'ftc',
                name: 'affiliates_legal_ftc',
                component: AffiliatesLegalFtc,
                meta: {
                  access_type: 'authorized',
                  pageTitle: 'Affiliates / FTC Guidelines',
                },
              }
            ]
          },
          {
            path: 'campaigns',
            name: 'affiliates-campaigns',
            component: AffiliatesCampaigns,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates / Your Campaigns',
            }
          },
          {
            path: 'payments',
            name: 'affiliates_payments',
            component: AffiliatesPayments,
            meta: {
              access_type: 'authorized',
              pageTitle: 'Affiliates / Payment History',
            }
          },
        ]
      },
      {
        path: 'error-multiple-profiles',
        name: 'multi-accounts',
        component: MultipleAccounts,
        meta: {
          access_type: 'authorized',
          pageTitle: 'Affiliates',
        }
      },
      {
        path: 'enroll',
        name: 'affiliates_no_active_account',
        component: AffiliatesAccountView,
        meta: {
          access_type: 'authorized',
          pageTitle: 'No Active Affiliate Account'
        }
      },
    ],
  },
  {
    path: '/affiliates-payments-print',
    name: 'affiliates_payments_print',
    component: PrintPaymentsList,
    meta: {
      access_type: 'authorized',
      pageTitle: 'Affiliates',
    }
  },
]

export default routes
